<template lang="pug">
div.color-select.type-radio(
	:class="selected && selected.value === item.value ? 'selected' : ''"
)
	span.image
		span.color(:style="'background-color: ' + item.value")
	span.name {{ item.title }}
</template>
<script>
export default {
	name: "ColorSelectItem",
	props: {
		item: {
			type: Object,
		},
		selected: {
			type: Object,
		},
	},

	setup() {

	}
}
</script>
